import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { ViewerReadyPayload } from './interfaces/viewer-ready-payload.interface';
import { isNonNullObject } from 'utilities';

export const ViewerReadyMessage: MessageHandler<ViewerReadyPayload> = {
  send(payload: ViewerReadyPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.ViewerReady, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is ViewerReadyPayload {
    return (
      isNonNullObject(payload) &&
      'viewerId' in payload &&
      typeof payload.viewerId === 'string' &&
      (!('capabilities' in payload) ||
        (Array.isArray(payload.capabilities) &&
          payload.capabilities.every(cap => typeof cap === 'string')))
    );
  },
};
